<recaptcha [size]="'invisible'"
           [hide]="true"
           [badge]="'bottomleft'"
           (captchaResponse)="onCaptchaResponse($event)">
</recaptcha>

<!-- invite box -->
<div *ngIf="hasInvite; else error_box" class="create-account-bgrnd invite-box-container" data-testid="inviteBox">
    <div [height]="30"></div>
    <div class="cnt-row-centered">
        <div class="step-tittle text-align-left landing-font b1Color">You've been invited to a Brixx organisation</div>
    </div>
    <div class="bodyTextOffset">
        <span class="b1Color check-box-label signin-text">Already have a Brixx Account for this email address? - <a (click)="goToSignIn()" class="termsLabel">Sign in</a> and you'll find the organisation has<br>
        been added to your organisation drop down list.
        </span> <br>
        <span class="b1Color check-box-label signin-text">
            If not you'll need to create a Brixx account for this address below. If this is not the email <br>
            address you wish to use just get in touch with the person that invited you and ask them to <br>
            change it.
        </span> <br>
        <span class="b1Color check-box-label signin-text">
            When your account has been created, we'll take you straight to the organisation to access any <br>
            plans that have been shared with you.
        </span>
    </div>
    <div class="cnt-column-centered">
        <div class="cnt-column">
            <div [height]="20"></div>
            <div class="input-container" style="max-width: 430px">
                <input #emailInput
                       disabled
                       id="email"
                       [(ngModel)]="emailAddress"
                       class="default-input"
                       type="email"
                       name="email"
                       placeholder="Your Email Address"
                       autocomplete="off"
                       [height]="40"
                       maxlength="100"
                       data-testid="regEmail-edit-input">
            </div>
            <div [height]="2"></div>
            <div [height]="2"></div>
            <div class="input-container">
                <input #passwordInput id="password" [(ngModel)]="newUser.passwordStr" (keyup)="onPasswordType()" class="default-input" type="password" name="password"
                       placeholder="Create a Secure Password" maxlength="48" minlength="8" autocomplete="off" [height]="40"
                       (focusout)="validatePassword()"
                       data-testid="registerPass-edit-input">
                <div [height]="2"></div>
                <div #pwdHints class="pwdHints" data-testid="pwdHints">
                    <div id="minLengthCheckMark" class="checkmark"></div><span>8+characters</span>
                    <div id="specialCheckMark" class="checkmark"></div><span>Numbers/special</span>
                    <div id="uppercaseCheckMark" class="checkmark"></div><span>Uppercase</span>
                    <div id="lowercaseCheckMark" class="checkmark"></div><span>Lowercase</span>
                </div>
                <div #passwordWrongMsg class="validation-failed-message" style="margin-top: -2px;margin-bottom: -5px;" data-testid="registerPass-edit-validityMark">​</div>
            </div>
            <div [height]="15"></div>
            <div class="input-container">
                <combo #positionsCombo
                       class="signup-btn"
                       hint="Your Position"
                       name="positionsCombo"
                       id="positions"
                       [hasOutline]="true"
                       [backgroundColor]="'white'"
                       (changeCaller)="validatePositions()"
                       [ComboData]="positions"
                       (focusout)="validatePositions()"
                       [autocomplete]="true"
                       [showImg]="true"
                       [(ngModel)]="newUser.selectedPositionId"
                       [height]="40"
                       [inputTextClass]="'large-field'"
                       [useFullWidth]="true"
                       testId="positionsCombo"
                       style="margin-top: 5px;">
                </combo>
                <div #positionWrongMsg class="validation-failed-message">​</div>
            </div>
            <simple-btn #signUpBtn
                        class="signup-btn"
                        [hoverTextColor]="'white'"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [text]="'Create an Account'"
                        [textCls]="'large-btn-text-500'"
                        [height]="50"
                        [cornerRadius]="30"
                        [horizontalPadding]="20"
                        (click)="signUp()"
                        data-testid="winRegistreSignUpBtn"
                        style="margin-top: 10px;">
            </simple-btn>
        </div>
    </div>
    <div [height]="14"></div>
    <div class="terms-block">
        <div class="font14bold b1Color" style="letter-spacing: 0.5px;">
            By creating an account you agree to our
            <a class="termsLabel" href="https://www.brixx.com/terms-conditions/" target="_blank">Terms &amp; Conditions</a>
            <span>&nbsp;&&nbsp;</span><a class="termsLabel" href="https://www.brixx.com/privacy-policy/" target="_blank">Privacy Policy</a>
        </div>
        <div [height]="5"></div>
        <div id="newsCheckBoxContainer" class="checkboxContainer">
            <input type="checkbox" (change)="toggleGetNews()" id="newsCheckBox" name="newsCheckBox" class="checkboxLeft newsCheckBox">
            <label for="newsCheckBox" data-testid="sendNewsCheckBox" style="width: 100%">
                <span class="b1Color" id="firstNewsRow">Be the first to know about our rapidly&nbsp;</span>
                <span class="b1Color" id="secondNewsRow">evolving platform and our blog posts</span>
            </label>
        </div>
    </div>
</div>

<!-- error box -->
<ng-template #error_box>
    <div class="email-not-found-container text-align-center">
    <span class="landing-text landing-font b1Color">
        {{!isEmailEmpty || !isValidEmail ? 'No email address specified.' : 'No invite for ' + emailAddress + ' found.'}}<br>
        Please contact our support if you require any help.
    </span>
        <simple-btn class="btn-email-not-found"
                    [text]="'OK'"
                    data-testid="GoBackButton"
                    (click)="goToLanding()"
                    [textCls]="'large-btn-text-500'"
                    [height]="40"
                    [width]="120"
                    [cornerRadius]="50"
                    [backgroundFillCls]="'transparent-background'"
                    [hoverFillCls]="'g4Background'"
                    [borderWidth]=2
                    [borderColorCls]="'g4Border'"
                    [hoverBorderColorCls]="'g4Border'"
                    [textColorCls]="'g4Color'"
                    [hoverTextColorCls]="'white-color'">
        </simple-btn>
    </div>
</ng-template>